export class RulebookCompare {
  /**
   * The Json object for topic list data.
   */
  public TREE_DATA = {
    "Env Topic & SubTopic": {
      Air: {
        "Air Quality": [
          "Permitting",
          "General Requirements for Hazardous Air Pollutants (HAPs)",
          "Miscellaneous Air Quality Programs and Performance Standards",
        ],
        "MACT Standards": [
          "40 CFR 63 Subpart Q - MACT Standards for Industrial Process Cooling Towers",
          "40 CFR 63 Subpart F - MACT Standards for the Synthetic Organic Chemical Manufacturing Industry (SOCMI)",
          "40 CFR 63 Subpart OO - MACT Standards for Equipment Leaks - Tanks",
          "40 CFR 63 Subpart PP - MACT Standards for Equipment Leaks - Containers",
          "40 CFR 63 Subpart QQ - MACT Standards for Equipment Leaks - Surface Impoundments",
          "40 CFR 63 Subpart RR - MACT Standards for Equipment Leaks - Individual Drain Systems",
          "40 CFR Subpart VV - MACT Standards for Equipment Leaks - Oil-Water Separators and Organic-Water Separators",
          "40 CFR 63 Subpart H - MACT Standards for Equipment Leaks",
          "40 CFR 63 Subpart I - MACT Standards for Certain Processes Subject to the Negotiated Regulation for Equipment Leaks",
          "40 CFR 63 Subpart T - MACT Standards for Halogenated Solvent Cleaning",
          "40 CFR 63 Subpart GG - MACT Standards for Aerospace Manufacturing and Reworking Facilities",
          "40 CFR 63 Subpart G - MACT Standards from SOCMI for Process Vents, Storage Vessels, Transfer Operations, and Wastewater",
          "40 CFR 63 Subpart N - MACT Standards for Hard and Decorative Chromium Electroplating and Chromium Anodizing Tanks",
          "40 CFR 63 Subpart II - MACT Standards for Shipbuilding and Ship Repair (Surface Coating) Operations",
          "40 CFR 63 Subpart ZZZZ - MACT Standards for Stationary Reciprocating Internal Combustion Engines (RICE)",
          "40 CFR 63 Subpart DDDDD - MACT Standards for Industrial, Commercial and Institutional Boilers and Process Heaters at Major Sources of HAP Emissions",
          "40 CFR 63 Subpart JJJJJJ - MACT Standards for Industrial, Commercial and Institutional Boilers at Area Sources of HAP Emissions",
          "40 CFR 63 Subpart CCCCCC - MACT Standards for Gasoline Dispensing Facilities at Area Sources",
        ],
        NESHAPs: [
          "40 CFR 61 Subpart M - NESHAP MACT Standards for Asbestos",
          "40 CFR 61 Subpart E - National Emission Standard for Mercury",
          "40 CFR 61 Subpart F - National Emission Standard for Vinyl Chloride",
          "40 CFR 61 Subpart V - National Emission Standard for Equipment Leaks from Fugitive Sources",
          "40 CFR 63 Subpart R - National Emission Standards for Gasoline Distribution Facilities (Bulk Gasoline Terminals and Pipeline Breakout Stations)",
        ],
        "New Source Performance Standards (NSPS)": null,
        "Ozone-Depleting Substances (ODSs)": null,
        "Hydrofluorocarbons (HFCs)": null,
        "Accidental Release Prevention - RMPs": null,
        "40 CFR 65 Subpart A - 40 CFR 65 Subpart G - Consolidated Air Rule for the Synthetic Organic Chemical Manufacturing Industry (SOCMI)":
          null,
        "Acid Rain Program": null,
        "Federal NOx Budget Trading Program (40 CFR 97)": null,
        "Greenhouse Gas Reporting Program": null,
        "Cross-State Air Pollution Rule (CSAPR) Trading Program": null,
      },
      "Bulk Storage/Spill Plans": {
        "General Requirements and SPCC Plans": null,
        "OPA 90": [
          "OPA 90-PHMSA, EPA, and BSEE Requirements",
          "OPA 90-Vessel Response Plans",
          "OPA 90-MTR Facility Response Plans and Operations Manuals",
        ],
        "Underground Storage Tanks": "Underground Storage Tanks",
      },
      "Chemical Management/Hazardous Materials": {
        "Denatured Alcohol": null,
        EPCRA: null,
        PCBs: null,
        Asbestos: null,
        "Releases and Notification": null,
        "Chemical Security Planning": null,
        "Formaldehyde Emissions From Wood Composite Products": null,
        "TSCA Section 6 Chemicals": null,
        "Pesticides, Herbicides, and Fungicides": null,
        "Toxic Substances Control Act": null,
      },
      "Drinking Water": null,
      "Radiation Protection": null,
      Waste: {
        "Hazardous Waste Generators": [
          "Very Small Quantity Generator Requirements",
          "Small Quantity Generator Requirements",
          "Large Quantity Generator Requirements",
        ],
        "Hazardous Waste TSD Facilities": [
          "TSD Facilities-General Requirements",
          "TSD Facilities-Specific Requirements",
        ],
        "Used Oil Management": null,
        "Universal Wastes": null,
        "Solid Waste": null,
      },
      Water: {
        Wastewater: [
          "Process Wastewater Discharges",
          "Discharges to Publicly Owned Treatment Works (POTWs) and to Private Treatment Works",
          "Underground Injection Control (UIC)",
          "National Pretreatment Standards",
        ],
        "Storm Water Discharges": null,
        Wetlands: null,
      },
    },
  };

  public TREE_DATA2 = {
    "OSHA Topic & SubTopic": {
      "Fire Safety and Emergency Preparedness": {
        "Fire Protection": null,
        "Exit Routes, Emergency Action Plans, and Fire Prevention Plans": null,
      },
      "Hazardous Materials and Processes": {
        "Compressed Gases": null,
        "Flammable Liquids": null,
        "Spray Finishing using Flammable and Combustible Materials": null,
        "Dip Tanks": null,
        Explosives: null,
        "Liquefied Petroleum Gas": null,
        "Anhydrous Ammonia": null,
        "Process Safety": null,
        "Boilers and Pressure Vessels": null,
        HAZWOPER: [
          "Hazardous Waste Cleanup Operations",
          "TSD Facilities",
          "Other Emergency Response Operations",
        ],
      },
      "General In-Plant Safety": {
        "Recordkeeping and Posting": null,
        "Personal Protective Equipment": null,
        "Confined Space": null,
        "Lockout and Tagout": null,
        "General Environmental Controls": null,
        "Medical and First Aid": null,
        "Materials Handling": [
          "General and Split Rim Wheels",
          "Powered Industrial Trucks",
          "Hoisting and Lifting Equipment",
        ],
        "Machinery and Machine Guarding": null,
        "Handheld Tools": null,
        "Welding, Cutting, and Brazing": null,
      },
      "Electrical Safety": null,
      "Surfaces, Platforms and Fall Protection": {
        "Walking and Working Surfaces": null,
        "Platforms and Manlifts": null,
      },
      "Industry-Specific Requirements": {
        Telecommunications: null,
        "Electric Power Generation, Transmission, and Distribution": null,
        "Pulp, Paper, and Paperboard Mills": null,
        Textiles: null,
        Bakeries: null,
        Sawmills: null,
        "Laundry Machinery and Operations": null,
        "Grain Handling Operations": null,
        "Other State-Specific Special Industries": null,
        Diving: null,
      },
      "Industrial Hygiene": {
        "Occupational Health": null,
        "Bloodborne Pathogens": null,
        "Hazard Communication": [
          "Hazard Communication Standard",
          "Chemical Hygiene Standard",
          "DOT Marking",
        ],
        "Chemical, Biological, and Physical Exposure Control": [
          "General Air Contaminants",
          "Medical Recordkeeping",
          "Ionizing Radiation",
          "1,2-Dibromo-3-Chloropropane (DBCP)",
          "1,3-Butadiene",
          "Acrylonitrile",
          "Asbestos",
          "Benzene",
          "Beryllium",
          "Cadmium",
          "Carcinogens",
          "Chromium (VI)",
          "Coke Oven Emissions",
          "Cotton Dust",
          "Ethylene Oxide",
          "Formaldehyde",
          "Inorganic Arsenic",
          "Lead",
          "Methylene Chloride",
          "Methylenedianiline (MDA)",
          "Respirable Crystalline Silica",
          "Vinyl Chloride",
        ],
      },
      "COVID‑19 Emergency Temporary Standard": null,
    },
  };

  public TOPIC_KEY_VALUE = new Map<string, string>([
    ["SL288720", "Permitting"],
    ["SL288779", "New Source Performance Standards (NSPS)"],
    ["SL288941", "General Requirements for Hazardous Air Pollutants (HAPs)"],
    [
      "SL288959",
      "40 CFR 63 Subpart F - MACT Standards for the Synthetic Organic Chemical Manufacturing Industry (SOCMI)",
    ],
    ["SL289018", "40 CFR 63 Subpart H - MACT Standards for Equipment Leaks"],
    [
      "SL289139",
      "40 CFR 63 Subpart OO - MACT Standards for Equipment Leaks - Tanks",
    ],
    [
      "SL289157",
      "40 CFR 63 Subpart PP - MACT Standards for Equipment Leaks - Containers",
    ],
    [
      "SL289189",
      "40 CFR 63 Subpart QQ - MACT Standards for Equipment Leaks - Surface Impoundments",
    ],
    [
      "SL289214",
      "40 CFR 63 Subpart RR - MACT Standards for Equipment Leaks - Individual Drain Systems",
    ],
    [
      "SL289242",
      "40 CFR 63 Subpart VV - MACT Standards for Equipment Leaks - Oil-Water Separators and Organic-Water Separators",
    ],
    [
      "SL15130210",
      "40 CFR 63 Subpart WW - MACT Standards for Storage Vessels Level 2 Controls",
    ],
    [
      "SL6503243",
      "40 CFR 63 Subpart I - MACT Standards for Certain Processes Subject to the Negotiated Regulation for Equipment Leaks",
    ],
    [
      "SL289292",
      "40 CFR 63 Subpart T - MACT Standards for Halogenated Solvent Cleaning",
    ],
    [
      "SL289334",
      "40 CFR 63 Subpart GG - MACT Standards for Aerospace Manufacturing and Reworking Facilities",
    ],
    ["SL289384", "40 CFR 61 Subpart M - NESHAP MACT Standards for Asbestos"],
    [
      "SL289459",
      "40 CFR 63 Subpart G - MACT Standards from SOCMI for Process Vents, Storage Vessels, Transfer Operations, and Wastewater",
    ],
    [
      "SL289502",
      "40 CFR 63 Subpart Q - MACT Standards for Industrial Process Cooling Towers",
    ],
    [
      "SL289518",
      "40 CFR 61 Subpart E - National Emission Standard for Mercury",
    ],
    [
      "SL289532",
      "40 CFR 61 Subpart F - National Emission Standard for Vinyl Chloride",
    ],
    [
      "SL289546",
      "40 CFR 61 Subpart V - National Emission Standard for Equipment Leaks from Fugitive Sources",
    ],
    [
      "SL289565",
      "40 CFR 63 Subpart R - National Emission Standards for Gasoline Distribution Facilities (Bulk Gasoline Terminals and Pipeline Breakout Stations)",
    ],
    [
      "SL289592",
      "40 CFR 63 Subpart N - MACT Standards for Hard and Decorative Chromium Electroplating and Chromium Anodizing Tanks",
    ],
    [
      "SL289625",
      "40 CFR 63 Subpart II - MACT Standards for Shipbuilding and Ship Repair (Surface Coating) Operations",
    ],
    [
      "SL6766644",
      "40 CFR 63 Subpart ZZZZ - MACT Standards for Stationary Reciprocating Internal Combustion Engines (RICE)",
    ],
    [
      "SL6973479",
      "40 CFR 63 Subpart DDDDD - MACT Standards for Industrial, Commercial and Institutional Boilers and Process Heaters at Major Sources of HAP Emissions",
    ],
    [
      "SL7224606",
      "40 CFR 63 Subpart JJJJJJ - MACT Standards for Industrial, Commercial and Institutional Boilers at Area Sources of HAP Emissions",
    ],
    [
      "SL6931399",
      "40 CFR 63 Subpart CCCCCC - MACT Standards for Gasoline Dispensing Facilities at Area Sources",
    ],
    ["SL1102080", "Ozone-Depleting Substances (ODSs)"],
    ["SL17341952", "Hydrofluorocarbons (HFCs)"],
    ["SL289807", "Accidental Release Prevention - RMPs"],
    [
      "SL289915",
      "40 CFR 65 Subpart A - 40 CFR 65 Subpart G - Consolidated Air Rule for the Synthetic Organic Chemical Manufacturing Industry (SOCMI)",
    ],
    ["SL289651", "Acid Rain Program"],
    ["SL1102058", "Federal NOx Budget Trading Program (40 CFR 97)"],
    [
      "SL289883",
      "Miscellaneous Air Quality Programs and Performance Standards",
    ],
    ["SL5934031", "Greenhouse Gas Reporting Program"],
    ["SL12468327", "Cross-State Air Pollution Rule (CSAPR) Trading Program"],
    ["SL290235", "Process Wastewater Discharges"],
    [
      "SL290282",
      "Discharges to Publicly Owned Treatment Works (POTWs) and to Private Treatment Works",
    ],
    ["SL290302", "Underground Injection Control (UIC)"],
    ["SL290358", "National Pretreatment Standards"],
    ["SL290678", "Storm Water Discharges"],
    ["SL290851", "Drinking Water"],
    ["SL291108", "Solid Waste"],
    ["SL1826718", "General Requirements and SPCC Plans"],
    ["SL292458", "OPA 90-PHMSA, EPA, and BSEE Requirements"],
    ["SL292561", "OPA 90-Vessel Response Plans"],
    ["SL292682", "OPA 90-MTR Facility Response Plans and Operations Manuals"],
    ["SL292893", "EPCRA"],
    ["SL293053", "Releases and Notification"],
    ["SL5934092", "Chemical Security Planning"],
    ["SL293451", "PCBs"],
    ["SL293572", "Asbestos"],
    ["SL13282477", "Formaldehyde Emissions From Wood Composite Products"],
    ["SL15304325", "TSCA Section 6 Chemicals"], //not include.
    ["SL293787", "Toxic Substances Control Act"],
    ["SL294108", "Underground Storage Tanks"],
    ["SL294292", "Radiation Protection"],
    ["SL281193", "Wetlands"],
    ["SL1858024", "Pesticides, Herbicides, and Fungicides"],
    ["SL293214", "Denatured Alcohol"],
    ["SL291461", "Very Small Quantity Generator Requirements"],
    ["SL291484", "Small Quantity Generator Requirements"],
    ["SL291576", "Large Quantity Generator Requirements"],
    ["SL291726", "TSD Facilities-General Requirements"],
    ["SL291971", "TSD Facilities-Specific Requirements"],
    ["SL292112", "Used Oil Management"],
    ["SL292173", "Universal Wastes"],
    ["SL276085", "Fire Protection"],
    [
      "SL273975",
      "Exit Routes, Emergency Action Plans, and Fire Prevention Plans",
    ],
    ["SL274639", "Compressed Gases"],
    ["SL274764", "Flammable Liquids"],
    ["SL274887", "Spray Finishing using Flammable and Combustible Materials"],
    ["SL274945", "Dip Tanks"],
    ["SL274980", "Explosives"],
    ["SL275062", "Liquefied Petroleum Gas"],
    ["SL275127", "Anhydrous Ammonia"],
    ["SL275228", "Process Safety"],
    ["SL275365", "Hazardous Waste Cleanup Operations"],
    ["SL1006101", "TSD Facilities"],
    ["SL1006100", "Other Emergency Response Operations"],
    ["SL273332", "Recordkeeping and Posting"],
    ["SL275622", "Personal Protective Equipment"],
    ["SL275765", "Confined Space"],
    ["SL275843", "Lockout and Tagout"],
    ["SL275917", "General Environmental Controls"],
    ["SL275991", "Medical and First Aid"],
    ["SL276189", "Boilers and Pressure Vessels"], //Compressed Gases topic (full topic)
    ["SL276370", "General and Split Rim Wheels"],
    ["SL276384", "Powered Industrial Trucks"],
    ["SL276425", "Hoisting and Lifting Equipment"],
    ["SL276669", "Machinery and Machine Guarding"],
    ["SL276890", "Handheld Tools"],
    ["SL276970", "Welding, Cutting, and Brazing"],
    ["SL278486", "Electrical Safety"],
    ["SL273568", "Walking and Working Surfaces"],
    ["SL274149", "Platforms and Manlifts"], //rulebook Powered Platforms
    ["SL277236", "Telecommunications"],
    ["SL277486", "Electric Power Generation, Transmission, and Distribution"],
    ["SL277674", "Pulp, Paper, and Paperboard Mills"],
    ["SL277884", "Textiles"],
    ["SL277975", "Bakeries"],
    ["SL278125", "Sawmills"],
    ["SL278217", "Laundry Machinery and Operations"],
    ["SL278262", "Grain Handling Operations"],
    ["SL777935", "Other State-Specific Special Industries"],
    ["SL278681", "Diving"], //Diving Operations
    ["SL274371", "Occupational Health"], //Occupational Health and Environmental Control
    ["SL279739", "Bloodborne Pathogens"],
    ["SL278853", "Hazard Communication Standard"],
    ["SL9467190", "Chemical Hygiene Standard"],
    ["SL9466669", "DOT Marking"],
    ["SL279165", "General Air Contaminants"],
    ["SL279656", "Medical Recordkeeping"],
    ["SL279632", "Ionizing Radiation"],
    ["SL279446", "1,2-Dibromo-3-Chloropropane (DBCP)"],
    ["SL279549", "1,3-Butadiene"],
    ["SL279465", "Acrylonitrile"],
    ["SL279176", "Asbestos"],
    ["SL279370", "Benzene"],
    ["SL11726703", "Beryllium"],
    ["SL279325", "Cadmium"],
    ["SL279214", "Carcinogens"],
    ["SL1102146", "Chromium (VI)"],
    ["SL279401", "Coke Oven Emissions"],
    ["SL279429", "Cotton Dust"],
    ["SL279486", "Ethylene Oxide"],
    ["SL279504", "Formaldehyde"],
    ["SL279254", "Inorganic Arsenic"],
    ["SL279282", "Lead"],
    ["SL279590", "Methylene Chloride"],
    ["SL279526", "Methylenedianiline (MDA)"],
    ["SL9966859", "Respirable Crystalline Silica"],
    ["SL279232", "Vinyl Chloride"],
    ["SL15304396", "COVID‑19 Emergency Temporary Standard"],
  ]);

  public getRid(rbname: string): string {
    for (let [key, value] of this.TOPIC_KEY_VALUE.entries()) {
      if (value === rbname) return key;
    }
    return "0";
  }

  public getRbName(rbid: string): string {
    for (let [key, value] of this.TOPIC_KEY_VALUE.entries()) {
      if (key === rbid) return value;
    }
    return "";
  }
}
